import api from '../../../api';
import { finish, error } from '../../../modules/countries/actions/update';

export function request(dispatch, { data }) {
    api.patch(`/countries`, data).then(
        response => dispatch(finish(response)),
        ({ errors }) => dispatch(error(errors))
    );
}
